/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAsientosRouteImport } from './routes/_app/asientos'
import { Route as AppAuditoriaRouteImport } from './routes/_app/auditoria'
import { Route as AppCargaRouteImport } from './routes/_app/carga'
import { Route as AppCierreRouteImport } from './routes/_app/cierre'
import { Route as AppCompartidasRouteImport } from './routes/_app/compartidas'
import { Route as AppConciliacionesRouteImport } from './routes/_app/conciliaciones'
import { Route as AppConciliarRouteImport } from './routes/_app/conciliar'
import { Route as AppEmpresasRouteImport } from './routes/_app/empresas'
import { Route as AppMovimientosRouteImport } from './routes/_app/movimientos'
import { Route as AppPiezasRouteImport } from './routes/_app/piezas'
import { Route as AppRevisionRouteImport } from './routes/_app/revision'
import { Route as AppTipoCambioRouteImport } from './routes/_app/tipo-cambio'
import { Route as AppUsuariosRouteImport } from './routes/_app/usuarios'
import { Route as AppArchivoIdRouteImport } from './routes/_app/archivo.$id'
import { Route as AppBorradorBorradorIdRouteImport } from './routes/_app/borrador.$borradorId'
import { Route as AppDocumentosIndexRouteImport } from './routes/_app/documentos.index'
import { Route as AppDocumentosClientesRouteImport } from './routes/_app/documentos.clientes'
import { Route as AppDocumentosEstadosDeCuentaRouteImport } from './routes/_app/documentos.estados-de-cuenta'
import { Route as AppExtractoArchivoIdRouteImport } from './routes/_app/extracto.$archivoId'
import { Route as AppLoteLoteIdRouteImport } from './routes/_app/lote.$loteId'
import { Route as AppMovimientoIdRouteImport } from './routes/_app/movimiento.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAsientosRoute = AppAsientosRouteImport.update({
  id: '/asientos',
  path: '/asientos',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditoriaRoute = AppAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AppRoute,
} as any)
const AppCargaRoute = AppCargaRouteImport.update({
  id: '/carga',
  path: '/carga',
  getParentRoute: () => AppRoute,
} as any)
const AppCierreRoute = AppCierreRouteImport.update({
  id: '/cierre',
  path: '/cierre',
  getParentRoute: () => AppRoute,
} as any)
const AppCompartidasRoute = AppCompartidasRouteImport.update({
  id: '/compartidas',
  path: '/compartidas',
  getParentRoute: () => AppRoute,
} as any)
const AppConciliacionesRoute = AppConciliacionesRouteImport.update({
  id: '/conciliaciones',
  path: '/conciliaciones',
  getParentRoute: () => AppRoute,
} as any)
const AppConciliarRoute = AppConciliarRouteImport.update({
  id: '/conciliar',
  path: '/conciliar',
  getParentRoute: () => AppRoute,
} as any)
const AppEmpresasRoute = AppEmpresasRouteImport.update({
  id: '/empresas',
  path: '/empresas',
  getParentRoute: () => AppRoute,
} as any)
const AppMovimientosRoute = AppMovimientosRouteImport.update({
  id: '/movimientos',
  path: '/movimientos',
  getParentRoute: () => AppRoute,
} as any)
const AppPiezasRoute = AppPiezasRouteImport.update({
  id: '/piezas',
  path: '/piezas',
  getParentRoute: () => AppRoute,
} as any)
const AppRevisionRoute = AppRevisionRouteImport.update({
  id: '/revision',
  path: '/revision',
  getParentRoute: () => AppRoute,
} as any)
const AppTipoCambioRoute = AppTipoCambioRouteImport.update({
  id: '/tipo-cambio',
  path: '/tipo-cambio',
  getParentRoute: () => AppRoute,
} as any)
const AppUsuariosRoute = AppUsuariosRouteImport.update({
  id: '/usuarios',
  path: '/usuarios',
  getParentRoute: () => AppRoute,
} as any)
const AppArchivoIdRoute = AppArchivoIdRouteImport.update({
  id: '/archivo/$id',
  path: '/archivo/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppBorradorBorradorIdRoute = AppBorradorBorradorIdRouteImport.update({
  id: '/borrador/$borradorId',
  path: '/borrador/$borradorId',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentosIndexRoute = AppDocumentosIndexRouteImport.update({
  id: '/documentos/',
  path: '/documentos/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentosClientesRoute = AppDocumentosClientesRouteImport.update({
  id: '/documentos/clientes',
  path: '/documentos/clientes',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentosEstadosDeCuentaRoute =
  AppDocumentosEstadosDeCuentaRouteImport.update({
    id: '/documentos/estados-de-cuenta',
    path: '/documentos/estados-de-cuenta',
    getParentRoute: () => AppRoute,
  } as any)
const AppExtractoArchivoIdRoute = AppExtractoArchivoIdRouteImport.update({
  id: '/extracto/$archivoId',
  path: '/extracto/$archivoId',
  getParentRoute: () => AppRoute,
} as any)
const AppLoteLoteIdRoute = AppLoteLoteIdRouteImport.update({
  id: '/lote/$loteId',
  path: '/lote/$loteId',
  getParentRoute: () => AppRoute,
} as any)
const AppMovimientoIdRoute = AppMovimientoIdRouteImport.update({
  id: '/movimiento/$id',
  path: '/movimiento/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/asientos': typeof AppAsientosRoute
  '/auditoria': typeof AppAuditoriaRoute
  '/carga': typeof AppCargaRoute
  '/cierre': typeof AppCierreRoute
  '/compartidas': typeof AppCompartidasRoute
  '/conciliaciones': typeof AppConciliacionesRoute
  '/conciliar': typeof AppConciliarRoute
  '/empresas': typeof AppEmpresasRoute
  '/movimientos': typeof AppMovimientosRoute
  '/piezas': typeof AppPiezasRoute
  '/revision': typeof AppRevisionRoute
  '/tipo-cambio': typeof AppTipoCambioRoute
  '/usuarios': typeof AppUsuariosRoute
  '/archivo/$id': typeof AppArchivoIdRoute
  '/borrador/$borradorId': typeof AppBorradorBorradorIdRoute
  '/documentos/clientes': typeof AppDocumentosClientesRoute
  '/documentos/estados-de-cuenta': typeof AppDocumentosEstadosDeCuentaRoute
  '/extracto/$archivoId': typeof AppExtractoArchivoIdRoute
  '/lote/$loteId': typeof AppLoteLoteIdRoute
  '/movimiento/$id': typeof AppMovimientoIdRoute
  '/documentos/': typeof AppDocumentosIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/asientos': typeof AppAsientosRoute
  '/auditoria': typeof AppAuditoriaRoute
  '/carga': typeof AppCargaRoute
  '/cierre': typeof AppCierreRoute
  '/compartidas': typeof AppCompartidasRoute
  '/conciliaciones': typeof AppConciliacionesRoute
  '/conciliar': typeof AppConciliarRoute
  '/empresas': typeof AppEmpresasRoute
  '/movimientos': typeof AppMovimientosRoute
  '/piezas': typeof AppPiezasRoute
  '/revision': typeof AppRevisionRoute
  '/tipo-cambio': typeof AppTipoCambioRoute
  '/usuarios': typeof AppUsuariosRoute
  '/': typeof AppIndexRoute
  '/archivo/$id': typeof AppArchivoIdRoute
  '/borrador/$borradorId': typeof AppBorradorBorradorIdRoute
  '/documentos/clientes': typeof AppDocumentosClientesRoute
  '/documentos/estados-de-cuenta': typeof AppDocumentosEstadosDeCuentaRoute
  '/extracto/$archivoId': typeof AppExtractoArchivoIdRoute
  '/lote/$loteId': typeof AppLoteLoteIdRoute
  '/movimiento/$id': typeof AppMovimientoIdRoute
  '/documentos': typeof AppDocumentosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/asientos': typeof AppAsientosRoute
  '/_app/auditoria': typeof AppAuditoriaRoute
  '/_app/carga': typeof AppCargaRoute
  '/_app/cierre': typeof AppCierreRoute
  '/_app/compartidas': typeof AppCompartidasRoute
  '/_app/conciliaciones': typeof AppConciliacionesRoute
  '/_app/conciliar': typeof AppConciliarRoute
  '/_app/empresas': typeof AppEmpresasRoute
  '/_app/movimientos': typeof AppMovimientosRoute
  '/_app/piezas': typeof AppPiezasRoute
  '/_app/revision': typeof AppRevisionRoute
  '/_app/tipo-cambio': typeof AppTipoCambioRoute
  '/_app/usuarios': typeof AppUsuariosRoute
  '/_app/': typeof AppIndexRoute
  '/_app/archivo/$id': typeof AppArchivoIdRoute
  '/_app/borrador/$borradorId': typeof AppBorradorBorradorIdRoute
  '/_app/documentos/clientes': typeof AppDocumentosClientesRoute
  '/_app/documentos/estados-de-cuenta': typeof AppDocumentosEstadosDeCuentaRoute
  '/_app/extracto/$archivoId': typeof AppExtractoArchivoIdRoute
  '/_app/lote/$loteId': typeof AppLoteLoteIdRoute
  '/_app/movimiento/$id': typeof AppMovimientoIdRoute
  '/_app/documentos/': typeof AppDocumentosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/asientos'
    | '/auditoria'
    | '/carga'
    | '/cierre'
    | '/compartidas'
    | '/conciliaciones'
    | '/conciliar'
    | '/empresas'
    | '/movimientos'
    | '/piezas'
    | '/revision'
    | '/tipo-cambio'
    | '/usuarios'
    | '/archivo/$id'
    | '/borrador/$borradorId'
    | '/documentos/clientes'
    | '/documentos/estados-de-cuenta'
    | '/extracto/$archivoId'
    | '/lote/$loteId'
    | '/movimiento/$id'
    | '/documentos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/asientos'
    | '/auditoria'
    | '/carga'
    | '/cierre'
    | '/compartidas'
    | '/conciliaciones'
    | '/conciliar'
    | '/empresas'
    | '/movimientos'
    | '/piezas'
    | '/revision'
    | '/tipo-cambio'
    | '/usuarios'
    | '/'
    | '/archivo/$id'
    | '/borrador/$borradorId'
    | '/documentos/clientes'
    | '/documentos/estados-de-cuenta'
    | '/extracto/$archivoId'
    | '/lote/$loteId'
    | '/movimiento/$id'
    | '/documentos'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/asientos'
    | '/_app/auditoria'
    | '/_app/carga'
    | '/_app/cierre'
    | '/_app/compartidas'
    | '/_app/conciliaciones'
    | '/_app/conciliar'
    | '/_app/empresas'
    | '/_app/movimientos'
    | '/_app/piezas'
    | '/_app/revision'
    | '/_app/tipo-cambio'
    | '/_app/usuarios'
    | '/_app/'
    | '/_app/archivo/$id'
    | '/_app/borrador/$borradorId'
    | '/_app/documentos/clientes'
    | '/_app/documentos/estados-de-cuenta'
    | '/_app/extracto/$archivoId'
    | '/_app/lote/$loteId'
    | '/_app/movimiento/$id'
    | '/_app/documentos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/asientos': {
      id: '/_app/asientos'
      path: '/asientos'
      fullPath: '/asientos'
      preLoaderRoute: typeof AppAsientosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/auditoria': {
      id: '/_app/auditoria'
      path: '/auditoria'
      fullPath: '/auditoria'
      preLoaderRoute: typeof AppAuditoriaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/carga': {
      id: '/_app/carga'
      path: '/carga'
      fullPath: '/carga'
      preLoaderRoute: typeof AppCargaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cierre': {
      id: '/_app/cierre'
      path: '/cierre'
      fullPath: '/cierre'
      preLoaderRoute: typeof AppCierreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/compartidas': {
      id: '/_app/compartidas'
      path: '/compartidas'
      fullPath: '/compartidas'
      preLoaderRoute: typeof AppCompartidasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conciliaciones': {
      id: '/_app/conciliaciones'
      path: '/conciliaciones'
      fullPath: '/conciliaciones'
      preLoaderRoute: typeof AppConciliacionesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conciliar': {
      id: '/_app/conciliar'
      path: '/conciliar'
      fullPath: '/conciliar'
      preLoaderRoute: typeof AppConciliarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/empresas': {
      id: '/_app/empresas'
      path: '/empresas'
      fullPath: '/empresas'
      preLoaderRoute: typeof AppEmpresasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/movimientos': {
      id: '/_app/movimientos'
      path: '/movimientos'
      fullPath: '/movimientos'
      preLoaderRoute: typeof AppMovimientosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/piezas': {
      id: '/_app/piezas'
      path: '/piezas'
      fullPath: '/piezas'
      preLoaderRoute: typeof AppPiezasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/revision': {
      id: '/_app/revision'
      path: '/revision'
      fullPath: '/revision'
      preLoaderRoute: typeof AppRevisionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tipo-cambio': {
      id: '/_app/tipo-cambio'
      path: '/tipo-cambio'
      fullPath: '/tipo-cambio'
      preLoaderRoute: typeof AppTipoCambioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/usuarios': {
      id: '/_app/usuarios'
      path: '/usuarios'
      fullPath: '/usuarios'
      preLoaderRoute: typeof AppUsuariosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/archivo/$id': {
      id: '/_app/archivo/$id'
      path: '/archivo/$id'
      fullPath: '/archivo/$id'
      preLoaderRoute: typeof AppArchivoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/borrador/$borradorId': {
      id: '/_app/borrador/$borradorId'
      path: '/borrador/$borradorId'
      fullPath: '/borrador/$borradorId'
      preLoaderRoute: typeof AppBorradorBorradorIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documentos/': {
      id: '/_app/documentos/'
      path: '/documentos'
      fullPath: '/documentos/'
      preLoaderRoute: typeof AppDocumentosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documentos/clientes': {
      id: '/_app/documentos/clientes'
      path: '/documentos/clientes'
      fullPath: '/documentos/clientes'
      preLoaderRoute: typeof AppDocumentosClientesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documentos/estados-de-cuenta': {
      id: '/_app/documentos/estados-de-cuenta'
      path: '/documentos/estados-de-cuenta'
      fullPath: '/documentos/estados-de-cuenta'
      preLoaderRoute: typeof AppDocumentosEstadosDeCuentaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/extracto/$archivoId': {
      id: '/_app/extracto/$archivoId'
      path: '/extracto/$archivoId'
      fullPath: '/extracto/$archivoId'
      preLoaderRoute: typeof AppExtractoArchivoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lote/$loteId': {
      id: '/_app/lote/$loteId'
      path: '/lote/$loteId'
      fullPath: '/lote/$loteId'
      preLoaderRoute: typeof AppLoteLoteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/movimiento/$id': {
      id: '/_app/movimiento/$id'
      path: '/movimiento/$id'
      fullPath: '/movimiento/$id'
      preLoaderRoute: typeof AppMovimientoIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAsientosRoute: typeof AppAsientosRoute
  AppAuditoriaRoute: typeof AppAuditoriaRoute
  AppCargaRoute: typeof AppCargaRoute
  AppCierreRoute: typeof AppCierreRoute
  AppCompartidasRoute: typeof AppCompartidasRoute
  AppConciliacionesRoute: typeof AppConciliacionesRoute
  AppConciliarRoute: typeof AppConciliarRoute
  AppEmpresasRoute: typeof AppEmpresasRoute
  AppMovimientosRoute: typeof AppMovimientosRoute
  AppPiezasRoute: typeof AppPiezasRoute
  AppRevisionRoute: typeof AppRevisionRoute
  AppTipoCambioRoute: typeof AppTipoCambioRoute
  AppUsuariosRoute: typeof AppUsuariosRoute
  AppIndexRoute: typeof AppIndexRoute
  AppArchivoIdRoute: typeof AppArchivoIdRoute
  AppBorradorBorradorIdRoute: typeof AppBorradorBorradorIdRoute
  AppDocumentosClientesRoute: typeof AppDocumentosClientesRoute
  AppDocumentosEstadosDeCuentaRoute: typeof AppDocumentosEstadosDeCuentaRoute
  AppExtractoArchivoIdRoute: typeof AppExtractoArchivoIdRoute
  AppLoteLoteIdRoute: typeof AppLoteLoteIdRoute
  AppMovimientoIdRoute: typeof AppMovimientoIdRoute
  AppDocumentosIndexRoute: typeof AppDocumentosIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAsientosRoute: AppAsientosRoute,
  AppAuditoriaRoute: AppAuditoriaRoute,
  AppCargaRoute: AppCargaRoute,
  AppCierreRoute: AppCierreRoute,
  AppCompartidasRoute: AppCompartidasRoute,
  AppConciliacionesRoute: AppConciliacionesRoute,
  AppConciliarRoute: AppConciliarRoute,
  AppEmpresasRoute: AppEmpresasRoute,
  AppMovimientosRoute: AppMovimientosRoute,
  AppPiezasRoute: AppPiezasRoute,
  AppRevisionRoute: AppRevisionRoute,
  AppTipoCambioRoute: AppTipoCambioRoute,
  AppUsuariosRoute: AppUsuariosRoute,
  AppIndexRoute: AppIndexRoute,
  AppArchivoIdRoute: AppArchivoIdRoute,
  AppBorradorBorradorIdRoute: AppBorradorBorradorIdRoute,
  AppDocumentosClientesRoute: AppDocumentosClientesRoute,
  AppDocumentosEstadosDeCuentaRoute: AppDocumentosEstadosDeCuentaRoute,
  AppExtractoArchivoIdRoute: AppExtractoArchivoIdRoute,
  AppLoteLoteIdRoute: AppLoteLoteIdRoute,
  AppMovimientoIdRoute: AppMovimientoIdRoute,
  AppDocumentosIndexRoute: AppDocumentosIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
